import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { usePaymentFlowStore } from '@fhs/cart/src/state/payment-stores/payment-flow-store';
import Dialog from 'components/dialog';
import { usePathname } from 'hooks/use-pathname';
import { useCRMEventsContext } from 'state/crm-events';
import { ErrorDialogViewComponentNames } from 'state/crm-events/constants';
import { useNetworkContext } from 'state/network';

function ErrorNetwork() {
  const { formatMessage } = useIntl();
  const { hasNetworkError } = useNetworkContext();
  const pathname = usePathname();
  const currentState = usePaymentFlowStore(state => state.currentState);
  const retryInfo = usePaymentFlowStore(state => state.retryInfo);
  const isOnPaymentCheckout = pathname === '/cart/payment';
  const isCheckoutCommitInProgress =
    currentState === 'committing' ||
    currentState === 'confirming' ||
    currentState === 'insertRequested';
  const isCheckoutPaymentFlowActive =
    isCheckoutCommitInProgress ||
    !!retryInfo ||
    (isOnPaymentCheckout && currentState !== 'idle');
  const shouldSuppressNetworkModal = isCheckoutPaymentFlowActive;
  const [browsingOffline, setBrowsingOffline] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { logErrorDialogView } = useCRMEventsContext();

  useEffect(() => {
    if (!hasNetworkError) {
      setIsOpen(false);
      setHasOpened(false);
      setBrowsingOffline(false);
    }
  }, [hasNetworkError]);

  useEffect(() => {
    if (shouldSuppressNetworkModal) {
      setIsOpen(false);
    }
  }, [shouldSuppressNetworkModal]);

  useEffect(() => {
    if (
      !hasOpened &&
      hasNetworkError &&
      !browsingOffline &&
      !shouldSuppressNetworkModal
    ) {
      setHasOpened(true);
      setIsOpen(true);
      logErrorDialogView(ErrorDialogViewComponentNames.NETWORK_ERROR_MODAL, 'Network Error');
    }
  }, [
    browsingOffline,
    hasNetworkError,
    hasOpened,
    shouldSuppressNetworkModal,
    logErrorDialogView,
  ]);

  return (
    <Dialog
      showDialog={isOpen}
      modalAppearanceEventMessage="Network Error"
      testID="error-network-dialog"
      heading={formatMessage({ id: 'lostNetworkConnectivity' })}
      body={formatMessage({ id: 'checkNetworkSettings' })}
      accessibilityLabel={formatMessage({ id: 'lostNetworkConnectivity' })}
      showCloseButton
      onDismiss={() => {
        setBrowsingOffline(true);
        setIsOpen(false);
      }}
    />
  );
}

export default ErrorNetwork;
